import { SearchHighlighting } from '@aipb/gulliver/castor/model';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-header-highlighting',
  templateUrl: './header-highlighting.component.html',
  styleUrls: ['./header-highlighting.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule]
})
export class HeaderHighlightingComponent implements OnChanges {
  @Input() item: CustomRecordItem;
  @Input() highlighting: SearchHighlighting = {};
  @Input() addMargin: boolean;
  expanded = false;
  private _highlights: string[] = [];

  private catalogEnv = inject(CatalogEnvService);

  get filteredHighlights() {
    return this._highlights.slice(0, 3).join('...');
  }

  get allHighlights() {
    return this._highlights.join('...');
  }

  ngOnChanges() {
    this._highlights = this.initHighlights();
  }

  private initHighlights(): string[] {
    if (!this.item || !(this.item[this.catalogEnv.env.castor.UUID] in this.highlighting)) {
      return [];
    }

    const highlights: string[] = [];

    Object.keys(this.highlighting[this.item[this.catalogEnv.env.castor.UUID]]).forEach((key) => {
      this.highlighting[this.item[this.catalogEnv.env.castor.UUID]][key].forEach((value) => {
        highlights.push(value);
      });
    });

    return highlights;
  }
}
